import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Headline from "../../../../components/UI/Headline";
import PositionTestLoadsForDINEN19971DIN1054EAPiles from "./PositionTestLoadsForDINEN19971DIN1054EAPiles/PositionTestLoadsForDINEN19971DIN1054EAPiles";
import PositionTestLoadsForSpecificationByGeotechnicalExperts from "./PositionTestLoadsForSpecificationByGeotechnicalExperts/PositionTestLoadsForSpecificationByGeotechnicalExperts";
import {
  setTestSequenceTypeDINEN19971DIN1054EAPiles,
  setTestSequenceTypeSpecificationByGeotechnicalExpert,
  selectTestSequenceType,
} from "../../../../store/slices/lvTextSlice";
import {
  TEST_SEQUENCE_TYPE_DIN_EN_1997_1_DIN_1054_EA_PFAEHLE,
  TEST_SEQUENCE_TYPE_SPECIFICATION_BY_GEOTECHNICAL_EXPERT,
} from "../../../../constants";

export default function LVText() {
  const { t } = useTranslation("translation");

  const testSequenceType = useSelector(selectTestSequenceType);
  const dispatch = useDispatch();

  return (
    <div className="mt-5">
      <fieldset>
        <Headline text={t("lvText.positionTestLoads.headline")} />
        <fieldset>
          <input
            type="radio"
            id="din"
            name="testsequencetype"
            value={TEST_SEQUENCE_TYPE_DIN_EN_1997_1_DIN_1054_EA_PFAEHLE}
            onClick={() => dispatch(setTestSequenceTypeDINEN19971DIN1054EAPiles())}
            checked={testSequenceType === TEST_SEQUENCE_TYPE_DIN_EN_1997_1_DIN_1054_EA_PFAEHLE}
          />
          <label>{t("lvText.positionTestLoads.optionDINEN19971DIN1054EAPiles")}</label>
        </fieldset>
        <div>
          <input
            type="radio"
            id="expert"
            name="testsequencetype"
            value={TEST_SEQUENCE_TYPE_SPECIFICATION_BY_GEOTECHNICAL_EXPERT}
            onClick={() => dispatch(setTestSequenceTypeSpecificationByGeotechnicalExpert())}
            checked={testSequenceType === TEST_SEQUENCE_TYPE_SPECIFICATION_BY_GEOTECHNICAL_EXPERT}
          />
          <label>{t("lvText.positionTestLoads.optionSpecificationByGeotechnicalExperts")}</label>
        </div>
      </fieldset>
      {testSequenceType === TEST_SEQUENCE_TYPE_DIN_EN_1997_1_DIN_1054_EA_PFAEHLE && (
        <PositionTestLoadsForDINEN19971DIN1054EAPiles />
      )}
      {testSequenceType === TEST_SEQUENCE_TYPE_SPECIFICATION_BY_GEOTECHNICAL_EXPERT && (
        <PositionTestLoadsForSpecificationByGeotechnicalExperts />
      )}
    </div>
  );
}
